const club = {
  clubs: 'Clubs',
  myClubs: 'My Clubs',
  exploreClubs: 'Explore Clubs',
  requested: 'Requested:',
  invited: 'Invited:',
  joinClub: 'Join Club',
  leaveClub: 'Leave Club',
  requestPending: 'Request Pending',
  invitation: 'Invitation',
  invitationDesc: 'You are being invited by the club director, do you wish to be a part of this club?',
  acceptInvitation: 'You are now the member of the invited club.',
  declineInvitation: 'You have declined to become a member of the invited club.',
  editClub: 'Edit Club',
  fixClubPayments: 'Fix club payments account issues.',
  setUpYourClubPayments: 'Set up your club payments to create an event.',
  about: 'About',
  clubDetails: 'Club Details',
  clubContact: 'Club Contact',
  clubAbout: 'About The Club',
  directors: 'Directors',
  organizers: 'Organizers',
  invitePlayers: 'Add Member(s)',
  importPlayersCSV: 'Import Players via CSV',
  removeMember: 'Remove member',
  removeMemberDesc: 'This member will be removed from the club',
  playerAddedSuccess: 'Players Added Successfully',
  importPlayers: 'Import Players',
  importMatchesCSV: 'Import Matches via CSV',
  importMatches: 'Import Matches',
  createNewEvent: 'Create New Event',
  eventDetails: 'Event Details',
  addOrganizers: 'Add Organizers',
  clubOrganizers: 'Club Organizers must have a DUPR account to be added to your club.',
  clubPlayers: 'Club Players must have a DUPR account to be added to your club.',
  addOrganizer: 'Add Organizer',
  addMember: 'Add Member(s)',
  inviteAPLayer: 'Invite a Player',
  inviteAPLayerDesc:
    'After you invite them, the invited player must sign up (create an account) with the email entered below to see his results.',
  clubName: 'Club Name',
  removeOrganizerTitle: 'Remove Club Organizer',
  removeOrganizerText: "Are you sure you'd like to remove this account as an organizer?",
  removeOrganizer: 'Confirm',
  createEventDesc:
    'Seeding and Registering is not available as we are currently working on connecting you to our API partners.',
  seedMatchesDesc:
    'Seeding is not available anymore. We want to promote our Event Management API partners, on the [Register] button you can now paste the URL of your event from other softwares',
  leaveDUPRWarning:
    'You will be redirected to the registration page and leave this DUPR page when clicking this button.',
  clubsNearMe: 'Clubs Near Me',
  clubPosts: 'Posts',
}

export type LocaleClub = typeof club

export default club
